export default __webpack_public_path__ + "static/media/013-mittens.2ac64c0d.svg";